<template>
  <div id="destination-order-list">
    <div class="card vx-card p-6">
      <div class="menu-section">
        <div class="header">
          <div class="icon-area">
            <feather-icon class="mr-2" icon="DownloadIcon" svgClasses="h-7 w-7" />
          </div>
          <div class="title">一括取込み</div>
        </div>
        <div class="menu-content">
          <div class="description">一括取込するファイルを選択してください。</div>
          <label for="file_upload" class="input">
            {{excelData ? excelData.name : "ファイルを選択" }}
            <input type="file" id="file_upload" @change="onExcelUploaded">
          </label>

          <div class="menu-button-area">
            <vs-button
              class="menu-button"
              color="#2D9CDB"
              :disabled="uploadButtonDisabled"
              @click="clickUpload"
            >
              <span class="import-button-inner">
                アップロード
              </span>
            </vs-button>
            <vs-button
              class="menu-button"
              color="#bdbdbd"
              :to="{name: 'addon-port-master-destination-order-list'}"
            >
              <span class="import-button-inner">
                キャンセル
              </span>
            </vs-button>
          </div>
        </div>
      </div>
    </div>
    <vs-popup
      class="basic-master-popup"
      title="新規データ登録の確認"
      :active.sync="popupActive"
      :button-close-hidden="true"
    >
      <p class="important-message">
        選択した取込みデータの中に新しい登録情報があります。
      </p>
      <p class="message">
        個別の管理画面から新規データの確認、詳細データを追加してください。
      </p>
      <div class="popup-list">
        <div class="popup-list-item" v-for="(item, index) in addDataItems" :key="index">
          <div class="item-name">
            {{item.name}}
          </div>
          <div class="item-column-name">
            {{item.columnName}}
          </div>
        </div>
      </div>
      <div class="button-area">
        <vs-button class="popup-button" color="#2D9CDB" @click="clickConfirm">一括取込み確認画面</vs-button>
      </div>
    </vs-popup>
    <vs-popup
      class="basic-master-popup"
      :title='customErrorTitle || "登録データの不足"'
      :active.sync="popupErrorActive"
    >
      <template v-if="!customErrorMessage">
        <p class="important-message">
          以下の対象データが入力されていません。
        </p>
        <p class="message">
          元の一括取込ファイルを修正して、再度取り込んでください。
        </p>
        <div class="popup-list">
          <div class="popup-list-item" v-for="(message, index) in errorMessages" :key="index">
            <div class="item-name">
              {{message}}
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <p class="important-message">
          {{customErrorMessage}}
        </p>
      </template>
      <div class="close-button-area">
        <vs-button class="popup-close-button" color="#2D9CDB" @click="popupErrorActive=false">閉じる</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import moment from 'moment'
import { createNamespacedHelpers } from "vuex";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
const { mapActions } = createNamespacedHelpers("portMasterDestinationWorkEdit")
const { mapState } = createNamespacedHelpers("portMaster");
const { mapState: mapStateOfPortMaster } = createNamespacedHelpers("portMaster");

export default {
  data() {
    return {
      selectedControl: null,
      orderList: [],
      configDayPicker: {
        dateFormat: "Y-m-d",
        time_24hr: true,
        defaultDate: new Date(),
        enable: [],
        locale: Japanese,
        static: true
      },
      excelData: null,
      popupActive: false,
      popupErrorActive: false,
      addDataItems: [],
      errorMessages: [],
      customErrorTitle: null,
      customErrorMessage: null
    }
  },
  async created() {
    this.$vs.loading()
    this.orderList = await this.fetchOrderList(this.selectedPort)
    this.$vs.loading.close()
  },
  mounted() {
    let routerViewElement = document.getElementsByClassName("router-view")
    routerViewElement[0].style.padding = "2.2rem"
  },
  computed: {
    ...mapState({
      selectedPort: state => state.selectedPort,
    }),
    ...mapStateOfPortMaster({
      selectedPort: state => state.selectedPort,
    }),    
    uploadButtonDisabled() {
      return this.excelData == null
    }
  },
  methods: {
    ...mapActions(["fetchOrderList", "importTask", "importDestinationWorkTasks"]),
    async clickUpload() {
      let payload = {
        portId: this.selectedPort.id,
        file: this.excelData
      }
      this.$vs.loading()
      let res = await this.importTask(payload)
      if (!res.status) {
        this.$vs.loading.close()
        this.customErrorTitle = "エラー"
        this.customErrorMessage = res.message
        this.popupErrorActive = true
      } else if (res.data.errors.length == 0 && (
        res.data.berths.length != 0 || 
        res.data.shipping_agencies.length != 0 || 
        res.data.vessels.length != 0
      )) {
        let berths = res.data.berths
        let agencies = res.data.shipping_agencies
        let vessels = res.data.vessels
        berths.forEach(element => {
          this.addDataItems.push({
            name: element.label ? element.label : element.name,
            columnName: "バース"
          })
        })
        agencies.forEach(element => {
          this.addDataItems.push({
            name: element.shipping_agency.name,
            columnName: "代理店"
          })
        })
        vessels.forEach(element => {
          this.addDataItems.push({
            name: element.label ? element.label : element.name,
            columnName: "船舶"
          })
        })

        let payload = {
          selectedPort: this.selectedPort,
          tasksData: res.data.tasks,
        }
        await this.importDestinationWorkTasks(payload)
        this.$vs.loading.close()
        this.popupActive = true
      } else if (res.data.errors.length != 0) {
        this.$vs.loading.close()
        this.customErrorTitle = null
        this.customErrorMessage = null
        this.errorMessages = res.data.errors
        this.popupErrorActive = true
      } else {
        let payload = {
          selectedPort: this.selectedPort,
          tasksData: res.data.tasks,
        }
        await this.importDestinationWorkTasks(payload)
        this.$vs.loading.close()
        this.$router.push(
          {
            name: "addon-port-master-destination-imported-work-edit",
          }
        )
      }
    },
    clickConfirm() {
      this.popupActive = false
      this.$router.push(
        {
          name: "addon-port-master-destination-imported-work-edit",
        }
      )
    },
    onExcelUploaded(e) {
      const excel = e.target.files[0]
      this.excelData = excel
    },
    clickOrderItem() {
      this.$router.push(
        {
          name: "addon-port-master-destination-work-edit"
        }
      )
    },
    dateChipText(date) {
      let today = moment(new Date()).format('YYYY/MM/DD')
      let tomorrow = moment(new Date()).add(1,'days').format('YYYY/MM/DD')
      let dayAfterTomorrow = moment(new Date()).add(2,'days').format('YYYY/MM/DD')
      if (date == today) {
        return '当日分'
      } else if (date == tomorrow) {
        return '翌日分'
      } else if (date == dayAfterTomorrow) {
        return '翌々日分'
      } else {
        return null
      }
    },
    getMasterData() {
      // portOption取得
      this.fetchPorts()
      // rank取得
      this.fetchRanks()
      // display取得
      this.fetchDisplaySettings()
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
#destination-order-list {
  .card {
    margin-top: 30px;
  }
  .menu-section {
    margin: 10px 0px;
  }
  .header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .icon-area {
      width: 36px;
    }
  }
  .flatpickr-input.active {
    border: 1px solid $pm-blue;
  }
  label > input {
    display:none;
  }
  label {
    color: #626262;
    padding: 10px;
    border: solid 1px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    cursor: pointer;
  }
  .menu-button-area {
    margin: 40px 0px 20px 0px;
    .menu-button {
      margin-right: 15px;
    }
  }
  .description {
    margin-bottom: 10px;
  }
  .menu-content {
    margin-left: 45px;
  }
  .title {
    font-weight: bold;
  }
  .input-label {
    font-weight: bold;
  }
  .import-label {
    margin-bottom: 19px;
  }
  .input {
    margin-bottom: 20px;
    margin-top: 10px;
  }
  .flatpickr-day.selected {
    background: $pm-blue !important;
    border-color: $pm-blue !important;
    &:hover {
      background: $pm-blue !important;
      border-color: $pm-blue !important;
    }
  }
}
.basic-master-popup {
  .popup-list {
    background: $pm-paper-white;
    overflow-y: scroll;
    padding: 0px 10px;
    max-height: 230px;
    margin: 20px 0px;
  }
  .popup-list-item {
    margin: 8px 0px;
    display: flex;
    justify-content: space-between;
  }
  .item-name, .important-message {
    font-weight: bold;
  }
  .item-column-name {
    margin-right: 10px;
  }
  .important-message {
    margin-bottom: 10px;
  }
  .popup-close-button {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
}

</style>
